export const StripeCancelSceneTranslation = {
  fi: {
    StripeCancelScene: {
      paymentCancelled: 'Maksu on peruutettu, eikä sitä veloiteta.',
      backLink: 'Takaisin tilaus sivulle.',
    },
  },
};
